export const ModuleInfoFeatureItem = ({
  icon,
  text,
}: {
  icon: React.ReactNode;
  text: string;
}) => (
  <div className="font-secondary flex h-[56px] w-full items-center gap-3 rounded-lg border-[1px] border-solid border-[#DEDFE0] p-4 ">
    <div className="h-6 w-6">{icon}</div>
    <span className="text-dark flex items-center text-sm font-medium">
      {text}
    </span>
  </div>
);
